

const CategoryColum=[
  {
    key: "name",
    id: "name",
    label: "Name",
    widget: "text"
  },
  {
    name: "Description",
    id: "description",
    label: "Description",
    widget: "richText"
  }
];

const Data=[
  {
    title:'Hot food',
    description:'food comment'
  },
  {
    title:'Sweet food',
    description:'food comment'
  },
  {
    title:'warm food',
    description:'food comment'
  }
];

export {CategoryColum,Data};